import { TmrBaseResource } from 'stylewhere/api'

export class SimpleItemList extends TmrBaseResource {
  static endpoint = 'tracking/api/v1/operations/simpleItemList'

  static batchValidateEndpoint() {
    return `${this.endpoint}/batchValidate`
  }
}
